document.querySelectorAll(".block__alphabetnav a").forEach(function (navItem) {
  navItem.addEventListener("click", function (evt) {
    evt.preventDefault();

    const contacts = document.querySelectorAll(".block__contact");
    let eventTarget = evt.target.getAttribute("href");
    // Show all contacts
    contacts.forEach(function (contact) {
      contact.style.display = "block";
    });

    if (navItem.classList.contains("active")) {
      navItem.classList.remove("active");
    } else {
      // Remove 'active' class from all nav items
      document
        .querySelectorAll(".block__alphabetnav a")
        .forEach(function (item) {
          item.classList.remove("active");
        });
      // Add 'active' class to the clicked nav item
      navItem.classList.add("active");

      // Loop through the contacts and filter based on the clicked letter
      contacts.forEach(function (contact) {
        contact.classList.add("newactive");
        const contactName = contact.querySelector(
          ".block__contact-name"
        ).textContent;
        const firstLetter = contactName.split(" ")[0][0].toLowerCase();
        const navText = navItem.textContent.toLowerCase();
        if (firstLetter !== navText) {
          contact.style.display = "none";
          contact.classList.remove("newactive");
        }
        if (contact.classList.contains(eventTarget) == true) {
          contact.style.display = "block";
        }
      });
    }
    // scrollevent();
  });
});

function myFunction() {
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName("li");
  for (i = 0; i < li.length; i++) {
    a = li[i].getElementsByTagName("a")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

function scrollevent() {
  if (document.querySelectorAll(".block__alphabetnav a.active").length < 1) {
    console.log("cliiiii");
    // Hide elements after the first 10
    const elements = document.querySelectorAll(".block__contactList div li");
    elements.forEach((el, index) => {
      if (index >= 30) {
        el.style.display = "none";
      }
    });
    let mincount = 10;
    let maxcount = 20;

    window.addEventListener("scroll", function () {
      if (
        document.querySelectorAll(".block__alphabetnav a.active").length < 1
      ) {
        if (
          window.scrollY + window.innerHeight >=
          document.documentElement.scrollHeight - 500
        ) {
          // Show elements within the mincount to maxcount range
          elements.forEach((el, index) => {
            if (index >= mincount && index < maxcount) {
              el.style.display = "block";
              el.style.transition = "opacity 1.5s ease-in-out";
              el.style.opacity = 1;
            }
          });

          mincount += 10;
          maxcount += 10;
        }
      }
    });
  }
}
// scrollevent();

document.querySelectorAll(".block__alphabetnav a").forEach(function (element) {
  element.addEventListener("click", function () {
    // scrollevent();

    document.querySelector(".block__search input").value = "";
  });
});
document
  .querySelector(".block__search input")
  .addEventListener("click", function () {
    document
      .querySelectorAll(".block__alphabetnav a")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  });
